import { render, staticRenderFns } from "./JoinEnter.vue?vue&type=template&id=6a6bf05d&scoped=true&"
import script from "./JoinEnter.vue?vue&type=script&lang=js&"
export * from "./JoinEnter.vue?vue&type=script&lang=js&"
import style0 from "./JoinEnter.vue?vue&type=style&index=0&id=6a6bf05d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6bf05d",
  null
  
)

export default component.exports